/**
 * @generated SignedSource<<78d9beed65b85417c531b9f308636444>>
 * @relayHash 3f8b7bb91ace1543a1f04562b04091b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a2e2b777c5ee42b9bf48b2d4941abddb1ed952d85e1942a2be06c0d3dae63930

import type { ConcreteRequest } from 'relay-runtime';
export type PageUpdateTrigger = "CONTENT_REDACTION" | "CREATE_PAGE" | "DISCARD_CHANGES" | "EDIT_PAGE" | "INLINE_TASK" | "LINK_REFACTORING" | "MIGRATE_PAGE_COLLAB" | "OWNER_CHANGE" | "PAGE_RENAME" | "PERSONAL_TASKLIST" | "REVERT" | "ROVO_FINALIZE" | "SPACE_CREATE" | "UNKNOWN" | "VIEW_PAGE" | "%future added value";
export type TaskStatus = "CHECKED" | "UNCHECKED" | "%future added value";
export type InlineTask = {
  status: TaskStatus;
  taskId: string;
};
export type SetBatchedTaskStatusMutation$variables = {
  contentId: string;
  tasks: ReadonlyArray<InlineTask | null>;
  trigger?: PageUpdateTrigger | null;
};
export type SetBatchedTaskStatusMutation$data = {
  readonly setBatchedTaskStatus: {
    readonly success: boolean;
  } | null;
};
export type SetBatchedTaskStatusMutation = {
  response: SetBatchedTaskStatusMutation$data;
  variables: SetBatchedTaskStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tasks"
  },
  {
    "defaultValue": "VIEW_PAGE",
    "kind": "LocalArgument",
    "name": "trigger"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "tasks",
            "variableName": "tasks"
          },
          {
            "kind": "Variable",
            "name": "trigger",
            "variableName": "trigger"
          }
        ],
        "kind": "ObjectValue",
        "name": "batchedInlineTasksInput"
      }
    ],
    "concreteType": "GraphQLMutationResponse",
    "kind": "LinkedField",
    "name": "setBatchedTaskStatus",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SetBatchedTaskStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetBatchedTaskStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3f8b7bb91ace1543a1f04562b04091b2",
    "id": "a2e2b777c5ee42b9bf48b2d4941abddb1ed952d85e1942a2be06c0d3dae63930",
    "metadata": {},
    "name": "SetBatchedTaskStatusMutation",
    "operationKind": "mutation",
    "text": "mutation SetBatchedTaskStatusMutation($contentId:ID!,$tasks:[InlineTask]!,$trigger:PageUpdateTrigger=VIEW_PAGE){setBatchedTaskStatus(batchedInlineTasksInput:{contentId:$contentId,tasks:$tasks,trigger:$trigger}){success}}"
  }
};
})();

(node as any).hash = "69534ca77b812c2f6a503bd25527650c";

export default node;
